import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-client-side-menu',
    templateUrl: './client-side-menu.component.html',
    styleUrls: ['./client-side-menu.component.scss'],
})
export class ClientSideMenuComponent implements OnInit {

    constructor(private router: Router) {
    }

    ngOnInit() {
    }

    goTo(path: string) {
        this.router.navigate([`/${path}`]);
    }
}
